import { styled } from '@ori-ui/mui';

import { SEARCH_PREVIEW_IMAGE_SIZE, SEARCH_PREVIEW_IMAGE_WRAPPER_HEIGHT } from '../../../SearchPreview/components';
import { Root as ProductRoot } from '../../../SearchPreview/components/SearchPreviewProduct/styles';
import { UnifiedSkeleton } from '../../../styles';

export const Root = styled(ProductRoot)(({ theme }) => ({
  cursor: 'unset',
}));

export const ImageSkeleton = styled(UnifiedSkeleton)(({ theme }) => ({
  width: SEARCH_PREVIEW_IMAGE_SIZE,
  height: SEARCH_PREVIEW_IMAGE_WRAPPER_HEIGHT,
  minWidth: SEARCH_PREVIEW_IMAGE_SIZE,
}));

export const QuickBuyButtonSkeleton = styled(UnifiedSkeleton)(({ theme }) => ({
  width: 35,
  height: 35,
  [theme.breakpoints.up('sm')]: {
    width: 45,
    height: 45,
  },
}));
